import { Component, ElementRef, OnInit, ViewChild, ChangeDetectorRef, TemplateRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { HomeService } from '../_services/home.service';
import { ToastrService } from 'ngx-toastr';
import { ErrorMessageService } from '../services/error-message.service';
import { HttpClient } from '@angular/common/http';
import Quill from 'quill';
import * as pako from 'pako';
import * as html2pdf from 'html2pdf.js';
import { finalize } from 'rxjs/operators';
import Swal from 'sweetalert2';
// Register custom blot
const Inline = Quill.import('blots/inline');
import { LoadingService } from '../_services/loading.service';
import { EmailverifyComponent } from '../verifymodel/emailverify/emailverify.component';
import { AuthService } from '../_services/auth.service';
import * as moment from 'moment'; // or use native JS

class NonEditableBlot extends Inline {
  static blotName = 'noneditable';
  static tagName = 'span';
  static className = 'non-editable';

  constructor(scroll: any, domNode: HTMLElement, private dialog: MatDialog,) {
    super(scroll, domNode);
    domNode.setAttribute('contenteditable', 'false');
  }
}

Quill.register(NonEditableBlot);

@Component({
  selector: 'app-rent-agreement-modal',
  templateUrl: './rent-agreement-modal.component.html',
  styleUrls: ['./rent-agreement-modal.component.scss']
})
export class RentAgreementModalComponent implements OnInit {
  @ViewChild('pdfContent') pdfContent!: ElementRef;
  @ViewChild('emailDialog') emailDialog!: TemplateRef<any>;
  dialogRef: MatDialogRef<any> | null = null;
  FileKey: any;
  editorContent: string = '';
  isOwnerSelected: boolean = false;
  isTenantSelected: boolean = false;
  editorModules = {
    toolbar: [
      ['bold', 'italic', 'underline'],
      [{ header: 1 }, { header: 2 }],
      [{ list: 'ordered' }, { list: 'bullet' }],
      ['clean'],
      [{ 'align': [] }],
    ]
  };
  data: any;
  emails: any;
  constructor(
    private dialog: MatDialog,
    private homeService: HomeService,
    private router: Router,
    private route: ActivatedRoute,
    private cd: ChangeDetectorRef,
    private toastr: ToastrService,
    private http: HttpClient,
    private errorMessageService: ErrorMessageService,
    private cdr: ChangeDetectorRef,
    private loadingService: LoadingService,
    private authService: AuthService,

  ) {
    const nav = this.router.getCurrentNavigation();
    this.data = nav?.extras.state?.data;
    console.log('Received data:>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>', this.data);
  }
  ngOnInit(): void {
    try {
      const userProfileString = localStorage.getItem('UserProfile');
      if (userProfileString) {
        const userProfile = JSON.parse(userProfileString);
        this.emails = userProfile.payload.email;
        console.log('this.emails', this.emails);

      }
    } catch (error) {
      console.error('Error parsing user profile from localStorage', error);
    }
    const currentDate = new Date().toLocaleDateString();

    const formattedCurrentDate = moment().format('DD-MM-YYYY');
    const formattedStart = moment(this.data?.startDate).format('DD-MM-YYYY');
    const formattedEnd = moment(this.data?.endDate).format('DD-MM-YYYY');

    this.editorContent = `
<div style="padding:20px;font-family:Nunito,sans-serif;line-height:1.6;">
  <h1 style="font-size:2.5em;text-align:center;margin-bottom:0.5em;">RENT AGREEMENT</h1>
  <p style="font-size:1.1em;">
    This Rent Agreement ("<b>Agreement</b>") is made and executed on this
    <b>${formattedCurrentDate}</b>, at <b>${this.data?.selectedCityName} , ${this.data?.stateName}</b>, by and between:
  </p>
  <hr style="border-top:2px solid#ccc;margin:1em 0;">

  <h3>PARTIES</h3>

  <h4>1. LANDLORD / LESSOR</h4>
<p style="font-size:1.1em;">
  <b>Name:</b> ${this.data?.ownerFullName}<br>
  <b>Father Name:</b> ${this.data?.ownerFatherName}<br>
  <b>Address:</b> ${this.data?.ownerAddress}, ${this.data?.ownerLocality} , ${this.data?.selectedCityName1} , ${this.data?.stateName1}<br>
  <b>Contact:</b> ${this.data?.ownerMobileCode} ${this.data?.ownerMobileNumber}<br>
  <b>Email:</b> ${this.data?.ownerEmail}<br>
  <b>Aadhaar No.:</b> ${this.data?.ownerAadharNumber}
</p>

  <p style="font-size:1.1em;"><b>AND</b></p>

  <h4>2. TENANT / LESSEE</h4>
<p style="font-size:1.1em;">
  <b>Name:</b> ${this.data?.tenantFullName}<br>
  <b>Father Name:</b> ${this.data?.tenantFatherName}<br>
  <b>Address:</b> ${this.data?.tenantAddress}, ${this.data?.tenantLocality}, ${this.data?.selectedCityName2} ,${this.data?.stateName2}<br>
  <b>Contact:</b> ${this.data?.tenantMobileCode} ${this.data?.tenantMobileNumber}<br>
  <b>Email:</b> ${this.data?.tenantEmail}<br>
  <b>Aadhaar No.:</b> ${this.data?.tenantAadharNumber}
</p>

  <hr style="border-top:2px solid#ccc;margin:1em 0;">

  <h2>WHEREAS:</h2>
  <ol style="font-size:1.1em;padding-left:1.5em;">
    <li>The Lessor is the lawful owner of the residential premises.</li>
    <li>The Lessee has approached the Lessor to rent the premises.</li>
    <li>The Lessor and Lessee agree to the terms below.</li>
  </ol>

  <hr style="border-top:2px solid#ccc;margin:1em 0;">

  <h2>1. DESCRIPTION OF PREMISES</h2>
  <p style="font-size:1.1em;">
    <b>Property Address:</b> ${this.data?.propertyAddress}, ${this.data?.propertyLocality}, ${this.data?.selectedCityName},${this.data?.stateName}<br>
  </p>

  <hr style="border-top:2px solid#ccc;margin:1em 0;">

  <h2>2. TERM OF TENANCY</h2>
  <ul style="font-size:1.1em;padding-left:1.5em;">
    <li>Valid from <b>${formattedStart}</b> to <b>${formattedEnd}</b>.</li>
  </ul>

  <hr style="border-top:2px solid#ccc;margin:1em 0;">

  <h2>3. MONTHLY RENT & PAYMENT TERMS</h2>
  <ul style="font-size:1.1em;padding-left:1.5em;">
    <li>Monthly Rent: <b>INR ${this.data?.rentPerMonth}</b>, payable in advance.</li>
    <li>Payment via Bank/UPI/Cheque/Cash to Lessor’s account (details to be exchanged).</li>
    <li>Utilities (electricity, water, internet, society charges) to be borne by Lessee.</li>
  </ul>

  <hr style="border-top:2px solid#ccc;margin:1em 0;">

  <h2>4. SECURITY DEPOSIT</h2>
  <p style="font-size:1.1em;padding-left:1.5em;">
    Lessee will deposit <b>INR ${this.data?.totalSecurity}</b> as refundable security, to be adjusted for dues or damage.
  </p>

  <hr style="border-top:2px solid#ccc;margin:1em 0;">

  <h2>5. USAGE OF PREMISES</h2>
  <ul style="font-size:1.1em;padding-left:1.5em;">
    <li>Use strictly for residential purposes.</li>
    <li>No commercial use or subletting without Lessor’s written consent.</li>
  </ul>

  <hr style="border-top:2px solid#ccc;margin:1em 0;">

  <h2>6. MAINTENANCE & REPAIRS</h2>
  <ul style="font-size:1.1em;padding-left:1.5em;">
    <li>Lessee responsible for regular upkeep & minor repairs.</li>
    <li>Lessor is responsible for structural and external repairs.</li>
    <li>Damage from misuse to be repaired at Lessee’s cost.</li>
  </ul>

  <hr style="border-top:2px solid#ccc;margin:1em 0;">

  <h2>7. ENTRY & INSPECTION</h2>
  <ul style="font-size:1.1em;padding-left:1.5em;">
    <li>Lessor may inspect with prior notice during reasonable hours.</li>
    <li>Emergency entry allowed in case of fire, flood, etc.</li>
  </ul>

  <hr style="border-top:2px solid#ccc;margin:1em 0;">

  <h2>8. TERMINATION & NOTICE PERIOD</h2>
  <ul style="font-size:1.1em;padding-left:1.5em;">
    <li>Either party must give at least 1 month’s written notice.</li>
    <li>Security deposit may be forfeited if Lessee terminates early.</li>
  </ul>

  <hr style="border-top:2px solid#ccc;margin:1em 0;">

  <h2>9. DEFAULT & BREACH</h2>
  <ul style="font-size:1.1em;padding-left:1.5em;">
    <li>Rent unpaid for 2 consecutive months or breach allows Lessor to terminate and take legal action.</li>
    <li>Illegal activities are grounds for immediate eviction.</li>
  </ul>

  <hr style="border-top:2px solid#ccc;margin:1em 0;">

  <h2>10. INDEMNITY</h2>
  <p style="font-size:1.1em;padding-left:1.5em;">
    Lessee indemnifies Lessor against claims arising from illegal use, injury to third parties, or violation of rules.
  </p>

  <hr style="border-top:2px solid#ccc;margin:1em 0;">

  <h2>11. GOVERNING LAW & JURISDICTION</h2>
  <p style="font-size:1.1em;">
    Governed by Indian laws. Jurisdiction: courts at <b>${this.data?.selectedCityName}</b>.
  </p>

  <hr style="border-top:2px solid#ccc;margin:1em 0;">

  <h2>12. ENTIRE AGREEMENT</h2>
  <p style="font-size:1.1em;">
    This document is the complete agreement. Any modifications must be in writing and signed.
  </p>

  <hr style="border-top:2px solid#ccc;margin:1em 0;">

  <h2>IN WITNESS WHEREOF</h2>
  <p style="font-size:1.1em;">
    The parties have executed this Agreement on the date first above written.
  </p>

  <hr style="border-top:2px solid#ccc;margin:1em 0;">

  <table style="width:100%;">
    <tr>
      <td style="width:50%;padding:1em;">
        <h3>LANDLORD / LESSOR</h3>
        <p style="font-size:1.1em;">
          Signature: _______________________<br>
          Name: ${this.data?.ownerFullName}<br>
          Date: ___________________________
        </p>
      </td>
      <td style="width:50%;padding:1em;">
        <h3>TENANT / LESSEE</h3>
        <p style="font-size:1.1em;">
          Signature: _______________________<br>
          Name: ${this.data?.tenantFullName}<br>
          Date: ___________________________
        </p>
      </td>
    </tr>
  </table>

  <hr style="border-top:2px solid#ccc;margin:1em 0;">

  <table style="width:100%;">
    <tr>
      <td style="width:50%;padding:1em;">
        <h3>WITNESS 1</h3>
        <p style="font-size:1.1em;">
          Name: __________________________<br>
          Address: ________________________<br>
          Signature: _______________________
        </p>
      </td>
      <td style="width:50%;padding:1em;">
        <h3>WITNESS 2</h3>
        <p style="font-size:1.1em;">
          Name: __________________________<br>
          Address: ________________________<br>
          Signature: _______________________
        </p>
      </td>
    </tr>
  </table>
</div>
`;


  }

  onEditorCreated(quill: any) {
    // Disable editing on readonly spans
    quill.root.addEventListener('keydown', function (e: any) {
      const selection = quill.getSelection();
      if (!selection) return;

      const [leaf] = quill.getLeaf(selection.index);
      const el = leaf?.domNode?.parentElement;

      if (el?.classList.contains('readonly')) {
        e.preventDefault();
      }
    });

  }


  toggleOwnerEmail() {
    if (this.data?.ownerEmail) {
      this.isOwnerSelected = !this.isOwnerSelected;
    }
  }

  toggleTenantEmail() {
    if (this.data?.tenantEmail) {
      this.isTenantSelected = !this.isTenantSelected;
    }
  }

  // Enable Submit only if at least one valid email is selected
  get isAnyEmailSelected(): boolean {
    return (
      (this.data?.ownerEmail && this.isOwnerSelected) ||
      (this.data?.tenantEmail && this.isTenantSelected)
    );
  }
  selectedEmails: any
  sendAgreement() {
    if (!this.isAnyEmailSelected) {
      console.warn('⚠ No email selected. Submission blocked.');
      return;
    }

    const ownerEmail = this.isOwnerSelected && this.data?.ownerEmail ? this.data.ownerEmail : null;
    const tenantEmail = this.isTenantSelected && this.data?.tenantEmail ? this.data.tenantEmail : null;

    // Combine non-null emails into a comma-separated string
    const selectedEmailsArray = [ownerEmail, tenantEmail].filter(email => !!email);
    this.selectedEmails = selectedEmailsArray.join(',');

    console.log('✔ Emails stored:', this.selectedEmails);
    this.downloadPDF()
  }

  savecheck() {
    const token = localStorage.getItem('access_token');

    /* 1️⃣  If user is not logged in, open your existing login / email dialog */
    if (!token) {
      this.dialogRef = this.dialog.open(this.emailDialog, {
        width: '500px',
        height: 'auto',
        disableClose: true,
      });
      return;
    }

    /* 2️⃣  User is logged‑in: check local profile for email‑verification flag */
    const profileData = localStorage.getItem('UserProfile');

    if (profileData) {
      const parsed = JSON.parse(profileData);
      const userEmail = parsed?.payload?.email;
      const isEmailVerified = parsed?.payload?.isEmailVerified;

      /* 3️⃣  If email is **not** verified, trigger the OTP + modal flow.
             Download starts only after successful verification.           */
      if (isEmailVerified !== 1) {
        this.onVerifyEmail(userEmail, () => {
          this.downloadPDF();   // called only after modal returns "verified"
        });
        return;                 // stop here until verification finishes
      }
    }

    /* 4️⃣  Email already verified → proceed directly */
    this.downloadPDF();
  }

  onVerifyEmail(email_Id: string, onVerifiedCallback?: () => void) {
    console.log("email_Id", email_Id);

    if (!email_Id) {
      console.error("Email ID is empty or undefined.");
      return;
    }

    this.authService.sendemailotp(email_Id).subscribe(
      (res: any) => {
        console.log('API Response:', res);

        if (res && res.status === 'SUCCESS') {
          this.toastr.success('OTP Sent successfully!', 'Success');
          this.showModal(email_Id, onVerifiedCallback); // ✅ Show modal after OTP sent
        }
        else if (res && res.status === 'EXCEPTION') {
          const errorMessage = this.errorMessageService.getErrorMessage(res.message);
          this.toastr.error(errorMessage, 'Error');
        }
        else if (res?.message) {
          const errorMessage = this.errorMessageService.getErrorMessage(res.message);
          this.toastr.error(errorMessage, 'Error');
        }
      },
      (error) => {
        const message = error?.error?.message || 'Failed to send OTP';
        const errorMessage = this.errorMessageService.getErrorMessage(message);
        this.toastr.error(errorMessage, 'Error');
      }
    );
  }

  showModal(email: string, onVerifiedCallback?: () => void): void {
    const dialogRef = this.dialog.open(EmailverifyComponent, {
      width: '450px',
      data: { email: email },
      disableClose: false,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result === 'verified') {
        this.toastr.success('Email Verified Successfully!', 'Success');
        if (onVerifiedCallback) {
          onVerifiedCallback(); // ✅ Continue with submission
        }
      } else {
        this.toastr.info('Email verification is required to proceed.', 'Verification Incomplete');
      }
    });
  }

  downloadPDF(): void {
    this.dialogRef.close();
    const element = document.createElement('div');
    element.innerHTML = this.editorContent;

    const options = {
      margin: 10,
      filename: 'rent-agreement.pdf',
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' }
    };
    this.loadingService.show();

    html2pdf()
      .from(element)
      .set(options)
      .outputPdf('blob')
      .then((pdfBlob: Blob) => {
        const pdfFile = new File([pdfBlob], 'rent-agreement.pdf', { type: 'application/pdf' });
        const purpose = 'rentAgreement';
        const mimeType = pdfFile.type;

        this.homeService.getMediaData(purpose, mimeType, pdfFile)
          .pipe(finalize(() => {
            console.log('Upload completed');
          }))
          .subscribe((res: any) => {
            console.log('Uploaded PDF URL:', res);
            this.loadingService.hide();
            this.FileKey = res?.url;

            if (this.FileKey) {
              this.submitContent();
            }
          });
      });
  }



  submitContent() {
    const payload = this.FileKey;

    const body = {
      // startDate: this.data.startDate,
      // endDate: this.data.endDate,
      // monthlyRent: this.data.rentPerMonth,
      // securityDeposite: this.data.totalSecurity,
      // propertyAddress: this.data.propertyAddress,
      // ownerName: this.data.ownerFullName,
      // tenantName: this.data.tenantFullName
      propertyAddress: this.data.propertyAddress || '',
      propertyLocality: this.data.propertyLocality || '',
      propertyCityId: this.data.propertyCityId || '',
      propertyStateId: this.data.propertyStateId || '',

      rentPerMonth: this.data.rentPerMonth || '',
      totalSecurity: this.data.totalSecurity || '',
      startDate: this.data.startDate || '',
      endDate: this.data.endDate || '',

      ownerFullName: this.data.ownerFullName || '',
      ownerFatherName: this.data.ownerFatherName || '',
      ownerAddress: this.data.ownerAddress || '',
      ownerLocality: this.data.ownerLocality || '',
      ownerCityId: this.data.ownerCityId || '',
      ownerStateId: this.data.ownerStateId || '',
      ownerMobileNumber: this.data.ownerMobileNumber || '',
      ownerEmail: this.data.ownerEmail || '',
      ownerAadharNumber: this.data.ownerAadharNumber || '',
      ownerMobileCode: this.data.ownerMobileCode || '+91',

      tenantFullName: this.data.tenantFullName || '',
      tenantFatherName: this.data.tenantFatherName || '',
      tenantAddress: this.data.tenantAddress || '',
      tenantLocality: this.data.tenantLocality || '',
      tenantCityId: this.data.tenantCityId || '',
      tenantStateId: this.data.tenantStateId || '',
      tenantMobileNumber: this.data.tenantMobileNumber || '',
      tenantEmail: this.data.tenantEmail || '',
      tenantAadharNumber: this.data.tenantAadharNumber || '',
      tenantMobileCode: this.data.tenantMobileCode || '+91'
    };

    const useEmails = this.emails && !this.selectedEmails;
    const useSelectedEmails = this.selectedEmails && !this.emails;

    if (useEmails || useSelectedEmails) {
      const emailData = useEmails ? this.emails : this.selectedEmails;

      // Combine everything into one object
      const mergedData = {
        ...body,
        path: payload,
        emails: emailData // or use a different key like "recipients" if needed
      };

      console.log("mergedData>>>>>>>>>>>>>>>>>>>>>>..", mergedData);

      this.loadingService.show();

      this.homeService.uploadrentagreement(mergedData).subscribe({
        next: (res: any) => {
          this.loadingService.hide();

          const message = res?.payload || 'Content submitted and emailed successfully';
          Swal.fire({
            icon: 'success',
            title: 'Success',
            text: message,
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true
          })
          .then(() => {
            this.router.navigate(['/rent-agreement']).then(() => {
              window.location.reload();
            });
          });
        },
        error: (err) => {
          const errorMessage =
            err?.error?.message || err?.message || 'Submission failed. Please try again.';
          this.toastr.error(errorMessage, 'Error');
          console.error(err);
        }
      });
    } else {
      this.toastr.warning('Please select only one: emails or selectedEmails.');
    }
  }


  back() {
    this.router.navigate(['/rent-agreement'])
  }


}
